import styled from "styled-components";
import { defaults } from "../../styles";

export const Container = styled(defaults.Container)`
  height: 100%;
  width: 100%;
  max-width: 600px;

  > div {
    width: 100%;
    align-content: flex-start;
    padding: 10px 0;

    & h3 {
      font-size: 18px;
    }

    & h5 {
      font-size: 14px;
      font-weight: normal;
    }
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
